// extracted by mini-css-extract-plugin
module.exports = {"switchersWrap":"grid-list-switch-module--switchersWrap--3Q2kX","toggleButton":"grid-list-switch-module--toggle-button--36oYd","active":"grid-list-switch-module--active--27LUP"};